<template>
    <section id="mainContainer">
        <userHeader></userHeader>
        <section class="mid-container">
            <section class="page-banner-section"
                :style="{ 'background-image': `url(${require('@/assets/images/services-banner-img.jpg')})` }">
                <div class="container">
                    <h1>{{ constants['OUR_SERVICES_TEXT'] }}</h1>
                </div>
            </section>
            <section id="tabsFixed" class="fold-menu-section">
                <div class="container">
                    <div class="custom-row">
                        <div class="fold_menu">
                            <ul id="teleporter">
                                <li v-for="(service, index) in serviceData" :key="index">
                                    <a :id="`tabs${index.toString()}`" href="javascript:void(0);" @click="scrollToSection(service.id)">{{ service.title}}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="fold_menu_receiver">
                            <ul id="receiver"></ul>
                            <div class="menu_arrow">
                                <button id="receiverClick"><img src="@/assets/images/angle-down-white.svg"
                                        alt="" /></button>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <section v-for="(service, index) in serviceData" :id="'section' + service.id"
                :class="['big-picture-fold', index % 2 === 0 ? 'b-f-left' : 'b-f-right']" :key="service.id">
                <div class="container clearfix">
                    <div class="big-picture">
                        <img :src="getCdnImageAddress(service.serviceImage, `w_575,h_457/`)" alt="" />
                    </div>
                    <div class="picture-content showcontent" id="readMoewaa">
                        <h4>{{ service.title }}</h4>
                        <div class="fold-txt-box">
                            <h5>
                                <p v-html="service.shortDescription"></p>
                            </h5>
                            <div class="b_p_txt">
                                <p v-html="getServiceDescription(service)"></p>
                            </div>
                        </div>
                        <div class="page_link" v-if="shouldShowServiceReadMore(service)">
                            <a href="javascript:void(0);" id="readMoewa" @click="toggleServiceDescription(service.id)">
                                {{ isExpandedService(service.id) ? '<< Read Less' : 'Read More >>' }}</a>
                        </div>
                    </div>
                </div>
            </section>
        </section>
        <userFooter></userFooter>
        <ChatbotPopup></ChatbotPopup>
    </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import userHeader from "@/components/userHeader.vue";
import axios from 'axios';
import { useRoute } from 'vue-router';
import userFooter from "@/components/userFooter.vue";
import constants from '@/utils/en-US-User.json';
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';
import ChatbotPopup from '@/components/chatbotPopup.vue';

interface Service {
    id: number;
    title: string;
    shortDescription: string;
    description: string;
    serviceImage: string;
}

export default defineComponent({
    name: "our-services",
    components: {
        userHeader,
        userFooter,
        ChatbotPopup
    },
    data() {
        return {
            constants,
            serviceId: '',
            serviceData: [] as Service[],
            expandedServiceIds: new Set<number>()

        };
    },
    created() {
        this.fetchServiceData();
    },
    methods: {
        async fetchServiceData() {
            try {
                const response = await axios.get(`${API_BASE_URL}/service/?status=1&selectedPage=services`);
                this.serviceData = response.data;
            } catch (err) {
                console.error(err);
            }
        },

        getServiceDescription(service: Service): string {
            const fullDescription = service.description;
            if (this.isExpandedService(service.id) || fullDescription.length <= 250) {
                return fullDescription;
            }
            return `${fullDescription.slice(0, 250)}...`;
        },

        shouldShowServiceReadMore(service: Service): boolean {
            return service.description.length > 250;
        },

        toggleServiceDescription(serviceId: number) {
            if (this.expandedServiceIds.has(serviceId)) {
                this.expandedServiceIds.delete(serviceId);
            } else {
                this.expandedServiceIds.add(serviceId);
            }
        },

        isExpandedService(serviceId: number): boolean {
            return this.expandedServiceIds.has(serviceId);
        },
        scrollToSection(serviceId: number) {
            const section = document.getElementById(`section${serviceId}`);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        },
        getCdnImageAddress(src: string, size: string): string {
            if (!src) return '';
            let cdnUrl: string = environment.imageCdn.getHost;
            cdnUrl = cdnUrl.concat(size);
            return cdnUrl + encodeURIComponent(src);
        }
    },
});
</script>